<template>
  <div class="auth-callback">
    {{ $t("auth.finishingLogin") }}
  </div>
</template>

<script>
export default {
  mounted() {
    this.getToken();
  },

  methods: {
    async getToken() {
      function postMessage(message) {
        [window.parent, window.opener, window].forEach(win => {
          if (win) {
            win.postMessage(message, window.location.origin);
          }
        });
      }

      if (this.$route.query.code) {
        const state = this.$auth.parseState(this.$route.query.state);
        const token = await this.$auth.exchangeCode(this.$route.query.code);

        postMessage({
          type: "auth.done",
          token,
          state
        });

        this.$router.replace(state.from ? state.from : "/customers");
      } else if (this.$route.query.error) {
        postMessage({
          type: "auth.fail"
        });

        this.$router.replace({
          name: "Login",
          query: { error: this.$route.query.error }
        });
      }
    }
  }
};
</script>
